import { components } from '../../layout/css/colors';

const fontFamily = 'Avenir Next';

export const newPartnerHubModalStyle = {
    m: '10px 0 0 0',
    p: 3,
    position: 'sticky',
    top: 0,
    zIndex: 100,
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    gap: '12px',
    fontFamily,
    bgcolor: components.selectionHover,
}